import React, { useState } from 'react';
import { Input, Button, Row, Col } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const DependencySearch = ({ dependencies, setFilteredData, searchText, setSearchText }) => {
  const handleSearch = (value) => {
    //setSearchText(value); // Actualiza el valor de búsqueda

    const filtered = dependencies.filter((record) => {
      // Filtramos en el tipo de dependencia y atributos
      const matchesAttributes = record.atributes?.some((attr) =>
        String(attr.value).toLowerCase().includes(value.toLowerCase())
      );
      const matchesType = record.type?.name?.toLowerCase().includes(value.toLowerCase());

      // Filtrar por la columna 'Asset'
      const matchesAsset = record.asset?.name?.toLowerCase().includes(value.toLowerCase());

      // Filtrar por el area
      const matchesArea = record.asset?.area?.name.toLowerCase().includes(value.toLowerCase());
    
      // También filtramos en los valores generales de las propiedades
      const matchesOtherFields = Object.values(record).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase())
      );
    
      // El registro será incluido si coincide en alguno de los campos
      return matchesOtherFields || matchesAttributes || matchesType || matchesAsset || matchesArea;
    });
    
    setFilteredData(filtered); // Actualiza los datos filtrados
  };

  /* const handleReset = () => {
    setSearchText('');  // Resetea el valor de búsqueda
    setFilteredData(dependencies);  // Resetea los datos a los originales
  }; */

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Dependencias"
          //value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
    </Col>
    </Row>
  );
};

export default DependencySearch;